import React from "react";

import { getFirestoreData, updateFirestoreWithOneObject } from 'store/actions/firestoreActions.jsx'
import { startSetUser, updateUser } from 'store/actions/profileActions.jsx'
import moment from "moment"
import { db, firebase } from "firebase/fbConfig.js"
import Button from "components/CustomButtons/Button.jsx";

// Get Users for Users Panel
export const startSetOrdersList = (uid) => {
  return (dispatch) => {
      db.collection("orders")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            shippingMode: docData.shippingMode ? docData.shippingMode : "N/A",
            origin: docData.origin ? docData.origin : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destination ? docData.destination : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",            
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {        
        dispatch(setOrdersList(data))
      })
  }
}

export const startSetPendingOrdersList = (status) => {
  return (dispatch) => {
      db.collection("orders").where("status", "==", status)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            shippingMode: docData.shippingMode ? docData.shippingMode : "N/A",
            origin: docData.origin ? docData.origin : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destination ? docData.destination : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",            
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {        
        dispatch(setPendingOrdersList(data))
      })
  }
}

export const startSetDispatchedOrdersList = (status) => {
  return (dispatch) => {
      db.collection("orders").where("status", "==", "dispatched")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            shippingMode: docData.shippingMode ? docData.shippingMode : "N/A",
            origin: docData.origin ? docData.origin : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destination ? docData.destination : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",            
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {        
        dispatch(setDispatchedOrdersList(data))
      })
  }
}

export const startSetDriverDispatchedOrdersList = (uid) => {
  return (dispatch) => {
      db.collection("orders").where("status", "==", "dispatched").where('pickUpCarrier', '==', uid)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            shippingMode: docData.shippingMode ? docData.shippingMode : "N/A",
            origin: docData.origin ? docData.origin : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destination ? docData.destination : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",            
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {        
        dispatch(setDispatchedOrdersList(data))
      })
  }
}


export const startSetConfirmedOrdersList = (status) => {
  return (dispatch) => {
      db.collection("orders").where("status", "==", "confirmed")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            shippingMode: docData.shippingMode ? docData.shippingMode : "N/A",
            origin: docData.origin ? docData.origin : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destination ? docData.destination : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",            
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {        
        dispatch(setConfirmedOrdersList(data))
      })
  }
}


export const startSetMyOrdersList = (uid) => {
  return (dispatch) => {
        db.collection("TEST-users").doc(uid).collection("orders")
        .get().then((snapshot) => {
          const data = []
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data()
            console.log(docData.status)
            var docObj = {
              id: doc.id,
              uid: docData.uid ? docData.uid : "N/A",
              deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
              origin: docData.originZip ? docData.originZip : "N/A",
              pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destinationZip ? docData.destinationZip : "N/A",
              dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
              class: docData.class ? docData.class : "N/A",
              submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
              status: docData.status ? docData.status : "N/A",            
            }
            data.push(docObj);
          })
          return (data)
        }, (error) => {
          console.log('error fetching data: ', error)
        }).then(data => {        
          dispatch(setOrdersList(data))
        })
    }
  }
  
  export const setOrdersList = (dataRows) => ({
    type: 'SET_ORDERS_LIST',
    dataRows
  })
  
  
  export const setPendingOrdersList = (dataRows) => ({
    type: 'SET_PENDING_ORDERS_LIST',
    dataRows
  })
  export const setDispatchedOrdersList = (dataRows) => ({
    type: 'SET_DISPATCHED_ORDERS_LIST',
    dataRows
  })
  export const setConfirmedOrdersList = (dataRows) => ({
    type: 'SET_CONFIRMED_ORDERS_LIST',
    dataRows
  })
  


// WEBPACK FOOTER //
// ./src/store/actions/ordersActions.jsx